export const formatLocalNumber = (value: number): string => value.toLocaleString('pt-BR')
